@if (form) {
  <div class="pb-4" [formGroup]="form">
    <!-- company details -->
    <div class="row row-gap-4" formGroupName="membershipCompanyDetails">
      <div class="col-12">
        <h3 class="m-0 font-16 fw-bold text-black pe-4 pb-2 border-2 border-bottom d-flex w-max">
          {{ "FRIENDS_OF_OMAN_MUSEUM.COMPANY_DETAILS" | translate }}
        </h3>
      </div>

      <!-- companyName -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.COMPANY_NAME" formControlName="companyName" />
      </div>

      <!-- crNumber -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.CR_NUMBER" formControlName="crNumber" />
      </div>

      <!-- ceoName -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.CEO_NAME" formControlName="ceoName" />
      </div>

      <!-- countryId -->
      <div class="col-md-6 col-lg-4">
        <app-dropdown
          label="FIELDS.COUNTRY"
          formControlName="countryId"
          [options]="countries()!"
          (selected)="getGovernorates($any($event))"
        />
      </div>

      <!-- governorateId -->
      @if (form.get("membershipCompanyDetails")!.get("governorateId")?.enabled || itemId) {
        <div class="col-md-6 col-lg-4">
          <app-dropdown
            label="FIELDS.GOVERNORATE"
            formControlName="governorateId"
            [options]="governorates()!"
            (selected)="getStates($any($event))"
          />
        </div>
      }

      <!-- stateId -->
      @if (form.get("membershipCompanyDetails")!.get("stateId")?.enabled || itemId) {
        <div class="col-md-6 col-lg-4">
          <app-dropdown label="FIELDS.STATE" formControlName="stateId" [options]="states()!" />
        </div>
      }

      <!-- phone -->
      <div class="col-md-6 col-lg-4">
        <app-input-text-dropdown
          label="FIELDS.COMPANY_MOBILE"
          formControlName="phone"
          dropdownFormControlName="countryCode"
          bindValue="phoneCode"
          [options]="countries()!"
          [dropdownSelectedValueRef]="dropdownSelectedValueRef"
          (selected)="getPhoneCountryCode($event)"
        />

        <ng-template #dropdownSelectedValueRef let-dropdownValue>
          <span dir="ltr">({{ dropdownValue }})</span>

          <img
            src="https://flagcdn.com/{{ phoneCountryCode?.toLowerCase() }}.svg"
            alt="{{ phoneCountryCode }}'s flag"
            loading="lazy"
            width="40"
            height="30"
          />
        </ng-template>
      </div>

      <!-- email -->
      <div class="col-md-6 col-lg-4">
        <app-input-text label="FIELDS.EMAIL" formControlName="email" contentType="email" />
      </div>

      <!-- zipCode -->
      <div class="col-sm-6 col-lg-4">
        <app-input-text label="FIELDS.ZIP_CODE" formControlName="zipCode" contentType="number" />
      </div>
    </div>
  </div>
}
